<template>
  <div class="main-doctor">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <h1 class="title-pages">FILIAL - TRANSFERÊNCIA DE RESIDENTE</h1>
      <b-overlay :show="loading" opacity="0.99">
        <!-- Seção de Filtros -->
        <div class="transfer-form-container v-clean">
          <div class="row">
            <div class="col-md-4 col-sm-12 mb-3">
              <label class="form-label">
                <i class="fas fa-filter mr-1"></i>
                RESIDENTES ATIVO/INATIVO
              </label>
              <select
                v-model="status_resident"
                class="form-control form-select-custom"
                @change="handleChangeStatusResident"
                aria-label="Filtro de status do residente"
              >
                <option :value="null">TODOS</option>
                <option value="ATIVO">ATIVO</option>
                <option value="INATIVO">INATIVO</option>
              </select>
            </div>
            <div class="col-md-4 col-sm-12 mb-3">
              <label class="form-label">
                <i class="fas fa-user mr-1"></i>
                RESIDENTE
              </label>
              <select
                v-model="resident_id"
                class="form-control form-select-custom"
                :disabled="!residents || residents.length === 0"
                aria-label="Seleção de residente"
              >
                <option value="">SELECIONE...</option>
                <option
                  v-for="resident in residents"
                  :key="resident.id"
                  :value="resident.id"
                >
                  {{ resident.name }}
                  {{
                    resident.already_transferred == 1
                      ? "(Já foi feito transferência)"
                      : ""
                  }}
                </option>
              </select>
            </div>
            <div class="col-md-4 col-sm-12 mb-3">
              <label class="form-label">
                <i class="fas fa-building mr-1"></i>
                FILIAL
              </label>
              <select
                v-model="rest_home_id"
                class="form-control form-select-custom"
                :disabled="!resthomes || resthomes.length === 0"
                aria-label="Seleção de filial"
              >
                <option value="">SELECIONE...</option>
                <option
                  v-for="rest_home in resthomes"
                  :key="rest_home.id"
                  :value="rest_home.id"
                >
                  {{ rest_home.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="mt-2">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="mt-3 text-right action-buttons">
            <confirmation-dialog
              :disabled="btnDisabled"
              header-class="modal-header"
              message-title="Deseja realmente solicitar a transferência do residente para a FILIAL selecionada?"
              message-body="Ao confirmar, não é possível reverter o processo."
              open-class="btn-save"
              open-left-icon="fa-exchange-alt"
              open-text="SOLICITAR TRANSFERÊNCIA"
              @yes="transfer"
            />
          </div>
        </div>

        <!-- Botão Atualizar -->
        <div class="mt-5 text-center">
          <button
            class="btn btn-save btn-update"
            :disabled="loading"
            @click="retrieve"
            aria-label="Atualizar listagens"
          >
            <i class="fas fa-sync-alt"></i> ATUALIZAR
          </button>
        </div>

        <!-- Solicitações Enviadas -->
        <div class="mt-4 transfer-section">
          <div class="section-header">
            <h2 class="section-title">
              <i class="fas fa-paper-plane mr-2"></i>
              Solicitações Enviadas
            </h2>
          </div>
          <div class="section-content">
            <div
              class="empty-state"
              v-show="residentsToRequestTransfer.length == 0"
            >
              <i class="fas fa-inbox empty-icon"></i>
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <v-data-table
              v-show="residentsToRequestTransfer.length > 0"
              :headers="headers"
              :items="residentsToRequestTransfer"
              :footer-props="{
                'items-per-page-options': [50, 75, 100],
                'items-per-page-text': 'Mostrar',
              }"
              @click:row="clickRowTable"
              class="custom-table"
            >
              <template v-slot:[`item.status`]="{ item }">
                <span
                  class="status-badge badge-pending"
                  v-if="item.transfer_request == 'PENDENTE'"
                >
                  <i class="fas fa-clock mr-1"></i>
                  PENDENTE
                </span>
                <span
                  class="status-badge badge-denied"
                  v-if="item.transfer_request == 'NEGADO'"
                >
                  <i class="fas fa-times-circle mr-1"></i>
                  NEGADO
                </span>
              </template>
              <template v-slot:[`item.resident`]="{ item }">
                <span class="resident-name">{{ item.name }}</span>
              </template>
              <template v-slot:[`item.rest_home`]="{ item }">
                <div class="rest-home-info">
                  <strong>{{ item.transfer_rest_home.name }}</strong>
                  <span
                    v-if="
                      item.transfer_rest_home.cnpj &&
                      item.transfer_rest_home.cnpj != 0
                    "
                    class="cnpj-text"
                  >
                    / {{ item.transfer_rest_home.cnpj }}
                  </span>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <confirmation-dialog
                  message-title="CANCELAR SOLICITAÇÃO?"
                  x_small
                  message-body="Deseja realmente cancelar a solicitação de transferência?"
                  open-class="btn-delete btn-action"
                  open-left-icon="fa-trash"
                  open-text="CANCELAR"
                  @yes="deleteRequestTransfer(item.id)"
                />
              </template>
            </v-data-table>
          </div>
        </div>

        <!-- Solicitações Recebidas -->
        <div class="mt-4 transfer-section">
          <div class="section-header">
            <h2 class="section-title">
              <i class="fas fa-inbox mr-2"></i>
              Solicitações Recebidas
            </h2>
          </div>
          <div class="section-content">
            <div class="mt-2">
              <ErrorsMessages :errors="errorsRefuse" />
              <ErrorsMessages :errors="errorsAccept" />
            </div>
            <div
              class="empty-state"
              v-show="residentsToAcceptTransfer.length == 0"
            >
              <i class="fas fa-inbox empty-icon"></i>
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <v-data-table
              v-show="residentsToAcceptTransfer.length > 0"
              :headers="headers"
              :items="residentsToAcceptTransfer"
              :footer-props="{
                'items-per-page-options': [50, 75, 100],
                'items-per-page-text': 'Mostrar',
              }"
              @click:row="clickRowTable"
              class="custom-table"
            >
              <template v-slot:[`item.status`]="{ item }">
                <span
                  class="status-badge badge-warning"
                  v-if="item.transfer_request == 'PENDENTE'"
                >
                  <i class="fas fa-hourglass-half mr-1"></i>
                  PENDENTE
                </span>
                <span
                  class="status-badge badge-denied"
                  v-if="item.transfer_request == 'NEGADO'"
                >
                  <i class="fas fa-times-circle mr-1"></i>
                  NEGADO
                </span>
              </template>
              <template v-slot:[`item.resident`]="{ item }">
                <span class="resident-name">{{ item.name }}</span>
              </template>
              <template v-slot:[`item.rest_home`]="{ item }">
                <div class="rest-home-info">
                  <strong>{{ item.request_rest_home.name }}</strong>
                  <span
                    v-if="
                      item.request_rest_home.cnpj &&
                      item.request_rest_home.cnpj != 0
                    "
                    class="cnpj-text"
                  >
                    / {{ item.request_rest_home.cnpj }}
                  </span>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div class="action-buttons-group">
                  <confirmation-dialog
                    message-title="NEGAR SOLICITAÇÃO?"
                    x_small
                    message-body="Deseja realmente negar a solicitação de transferência?"
                    open-class="btn-delete btn-action m-1"
                    open-left-icon="fa-times"
                    open-text="NEGAR"
                    @yes="refuseRequestTransfer(item.id)"
                  />
                  <b-modal
                    title="CONFIRMAÇÃO"
                    :id="`acceptRequestTransfer-${item.id}`"
                    hide-footer
                    hide-header-close
                    no-close-on-backdrop
                    no-close-on-esc
                    centered
                    header-class="modal-header-ok"
                  >
                    <div class="modal-body-custom">
                      <div class="row">
                        <div class="col-md-12">
                          <h6 class="modal-subtitle">
                            O QUE DESEJA TRANSFERIR?
                          </h6>
                          <p class="modal-text worksansr">
                            Selecione abaixo as informações que você deseja
                            transferir para a filial:
                            <strong>{{ item.request_rest_home.name }}</strong>
                          </p>
                          <p class="modal-info worksansr">
                            <i class="fas fa-info-circle mr-1"></i>
                            Por padrão já vai os dados cadastrais do residente!
                          </p>
                        </div>
                        <div class="col-md-12">
                          <div class="checkbox-group">
                            <div class="form-check custom-checkbox">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value="group_prescription_care"
                                id="group_prescription_care"
                                v-model="group_prescription_care"
                              />
                              <label
                                class="form-check-label"
                                for="group_prescription_care"
                              >
                                <i class="fas fa-prescription mr-1"></i>
                                PRESCRIÇÕES
                              </label>
                            </div>
                            <div class="form-check custom-checkbox">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value="care"
                                id="care"
                                v-model="care"
                              />
                              <label class="form-check-label" for="care">
                                <i class="fas fa-notes-medical mr-1"></i>
                                ANOTAÇÃO DE CUIDADOS
                              </label>
                            </div>
                            <div class="form-check custom-checkbox">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value="care_vital_signs"
                                id="care_vital_signs"
                                v-model="care_vital_signs"
                              />
                              <label
                                class="form-check-label"
                                for="care_vital_signs"
                              >
                                <i class="fas fa-heartbeat mr-1"></i>
                                SINAIS VITAIS
                              </label>
                            </div>
                            <div class="form-check custom-checkbox">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value="order"
                                id="order"
                                v-model="order"
                              />
                              <label class="form-check-label" for="order">
                                <i class="fas fa-file-medical mr-1"></i>
                                PEDIDOS MÉDICOS
                              </label>
                            </div>
                            <div class="form-check custom-checkbox">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value="evolution"
                                id="evolution"
                                v-model="evolution"
                              />
                              <label class="form-check-label" for="evolution">
                                <i class="fas fa-chart-line mr-1"></i>
                                EVOLUÇÕES
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-md-6 mb-2">
                          <button
                            class="btn btn-exit w-100"
                            @click="
                              $bvModal.hide(`acceptRequestTransfer-${item.id}`)
                            "
                          >
                            <i class="fas fa-times mr-1"></i>
                            CANCELAR
                          </button>
                        </div>
                        <div class="col-md-6 mb-2">
                          <button
                            class="btn btn-save w-100"
                            @click="acceptRequestTransfer(item.id)"
                          >
                            <i class="fas fa-check mr-1"></i>
                            ACEITAR
                          </button>
                        </div>
                      </div>
                    </div>
                  </b-modal>
                  <button
                    class="btn btn-save btn-action m-1"
                    @click="$bvModal.show(`acceptRequestTransfer-${item.id}`)"
                  >
                    <i class="fas fa-check"></i>
                    ACEITAR
                  </button>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar.vue";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired.vue";

import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "Branch",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      loading: false,
      errors: [],
      errorsAccept: [],
      errorsRefuse: [],
      residents: [],
      resident_id: "",
      resthomes: [],
      rest_home_id: "",
      status_resident: null,
      residentsToRequestTransfer: [],
      residentsToAcceptTransfer: [],
      group_prescription_care: false,
      care: false,
      care_vital_signs: false,
      order: false,
      evolution: false,
      headers: [
        { text: "STATUS", value: "status", width: "120px" },
        { text: "RESIDENTE", value: "resident" },
        { text: "FILIAL", value: "rest_home" },
        { text: "AÇÕES", value: "action", width: "200px", sortable: false },
      ],
    };
  },

  computed: {
    btnDisabled() {
      return !this.resident_id || !this.rest_home_id;
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    clickRowTable({ id }) {
      id;
    },

    handleChangeStatusResident() {
      this.residents = [];
      this.resident_id = "";
      this.getResidents();
    },

    retrieve() {
      this.errors = [];
      this.errorsAccept = [];
      this.errorsRefuse = [];

      this.getResidents();
      this.getResidentsToRequestTransfer();
      this.getResidentsToAcceptTransfer();
      this.getRestHomes();
    },

    async getResidents() {
      try {
        this.loading = true;

        let { status_resident } = this;

        let params = { status_resident };

        const response = await api.get("/branch/residents-to-transfer", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidentsToRequestTransfer() {
      try {
        this.loading = true;

        const response = await api.get("/branch/residents-to-request-transfer");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residentsToRequestTransfer = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidentsToAcceptTransfer() {
      try {
        this.loading = true;

        const response = await api.get("/branch/residents-to-accept-transfer");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residentsToAcceptTransfer = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getRestHomes() {
      try {
        this.loading = true;

        const response = await api.get("/resthomes");

        const { error, errors, resthomes } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.resthomes = resthomes;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async transfer() {
      try {
        this.loading = true;

        let { resident_id, rest_home_id } = this;

        let data = { resident_id, rest_home_id };

        let response = await api.post("/branch/request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async deleteRequestTransfer(id) {
      try {
        this.loading = true;

        let data = { id };

        let response = await api.put("/branch/cancel-request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async acceptRequestTransfer(id) {
      try {
        this.loading = true;
        this.errors = [];
        this.errorsAccept = [];
        this.errorsRefuse = [];

        let {
          group_prescription_care,
          care,
          care_vital_signs,
          order,
          evolution,
        } = this;

        let data = {
          id,
          group_prescription_care,
          care,
          care_vital_signs,
          order,
          evolution,
        };

        let response = await api.put("/branch/accept-request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errorsAccept = errors;
        } else {
          this.errorsAccept = [];
          toast(message, "success");
          this.$bvModal.hide(`acceptRequestTransfer-${id}`);
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async refuseRequestTransfer(id) {
      try {
        this.loading = true;
        this.errors = [];
        this.errorsAccept = [];
        this.errorsRefuse = [];

        let data = { id };

        let response = await api.put("/branch/refuse-request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errorsRefuse = errors;
        } else {
          this.errorsRefuse = [];
          toast(message, "success");
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Formulário de Transferência */
.transfer-form-container {
  background: #fff;
  border-radius: 4px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  margin-top: 1.5rem;
}

.form-label {
  font-size: 13px;
  color: #33495e;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  display: block;
}

.form-select-custom {
  font-size: 14px;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
}

.form-select-custom:focus {
  border-color: #33495e;
  box-shadow: 0 0 0 0.2rem rgba(51, 73, 94, 0.15);
}

.form-select-custom:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Seções de Solicitações */
.transfer-section {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.section-header {
  background: linear-gradient(135deg, #33495e 0%, #1f5a76 100%);
  padding: 1rem 1.5rem;
}

.section-title {
  color: #fff;
  font-size: 18px;
  text-transform: uppercase;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-content {
  padding: 1.5rem;
}

/* Estado Vazio */
.empty-state {
  padding: 3rem 1rem;
  text-align: center;
  background: #f9f9f9;
  border-radius: 4px;
}

.empty-icon {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 1rem;
}

/* Badges de Status */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.badge-pending {
  background-color: #e6b901;
  color: #fff;
}

.badge-warning {
  background-color: #f88a14;
  color: #fff;
}

.badge-denied {
  background-color: #c0392b;
  color: #fff;
}

/* Informações da Tabela */
.resident-name {
  font-weight: 500;
  color: #33495e;
}

.rest-home-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.cnpj-text {
  font-size: 12px;
  color: #666;
}

/* Botões de Ação */
.btn-action {
  font-size: 12px;
  padding: 0.375rem 0.75rem;
  min-width: auto;
}

.action-buttons-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.btn-update {
  min-width: 200px;
  font-weight: 600;
}

/* Modal Customizado */
.modal-body-custom {
  padding: 1.5rem;
}

.modal-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: #33495e;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.modal-text {
  font-size: 14px;
  color: #444;
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.modal-info {
  font-size: 13px;
  color: #30915b;
  padding: 0.75rem;
  background: #e8f5e9;
  border-radius: 4px;
  border-left: 3px solid #30915b;
  margin-bottom: 1.5rem;
}

/* Checkboxes Customizados */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.custom-checkbox {
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.custom-checkbox:hover {
  background-color: #f8f9fa;
  border-color: #33495e;
}

.custom-checkbox .form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.125rem;
  cursor: pointer;
}

.custom-checkbox .form-check-label {
  font-size: 14px;
  font-weight: 500;
  color: #33495e;
  cursor: pointer;
  margin-left: 0.5rem;
}

/* Tabela Customizada */
.custom-table >>> .v-data-table__wrapper {
  border-radius: 4px;
  overflow: hidden;
}

.custom-table >>> thead th {
  font-size: 13px !important;
  color: #33495e !important;
  text-transform: uppercase;
}

/* Responsividade */
@media (max-width: 768px) {
  .transfer-form-container {
    padding: 1rem;
  }

  .section-header {
    padding: 0.75rem 1rem;
  }

  .section-title {
    font-size: 16px;
  }

  .section-content {
    padding: 1rem;
  }

  .action-buttons {
    text-align: center !important;
  }

  .action-buttons-group {
    flex-direction: column;
  }

  .btn-action {
    width: 100%;
  }

  .modal-body-custom {
    padding: 1rem;
  }
}

@media (max-width: 576px) {
  .form-label {
    font-size: 12px;
  }

  .form-select-custom {
    font-size: 13px;
  }

  .section-title {
    font-size: 14px;
  }

  .empty-icon {
    font-size: 36px;
  }
}

/* Acessibilidade */
.form-select-custom:focus,
.form-check-input:focus,
button:focus {
  outline: 2px solid #33495e;
  outline-offset: 2px;
}

/* Animações suaves */
.transfer-section,
.transfer-form-container {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Imagem de foto (do código original) */
.main-doctor .photo-url {
  width: 25px;
  height: 25px;
  object-fit: cover !important;
  border-radius: 100%;
}
</style>